module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/fp/_falseOptions.js
// module id = 41
// module chunks = 1